import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Redux/index';
import { HelmetProvider } from 'react-helmet-async';
import { SiteConfigProvider } from './contexts/SiteConfigContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
  <Provider store={store}>
  <BrowserRouter>
  <SiteConfigProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </SiteConfigProvider>
  </BrowserRouter>
  </Provider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
